import { t as uiText } from '../i18n';
import { getAuth } from 'firebase/auth';

// Functions の URL は env のプロジェクトID（VITE_FIREBASE_PROJECT_ID）から組み立てる。
// これにより staging（notreu-stg-1132）/ production（eq-board）が自動で切り替わる。
const FUNCTIONS_REGION = 'us-central1';
const PROJECT_ID = (import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined) || 'eq-board';
const FUNCTIONS_BASE_URL = `https://${FUNCTIONS_REGION}-${PROJECT_ID}.cloudfunctions.net`;

const ANALYZE_URL = `${FUNCTIONS_BASE_URL}/sudachiAnalyzeFn`;
const TOKENIZE_URL = `${FUNCTIONS_BASE_URL}/sudachiTokenizeFn`;

export type SplitMode = 'A' | 'B' | 'C' | 'auto';

export interface AnalyzeFilters {
  pos?: string[];
  stopwords?: string[];
  minLen?: number;
}

export interface AnalyzeRequest {
  text: string;
  workspaceId: string;
  mode?: SplitMode;
  normalize?: boolean;
  filters?: AnalyzeFilters;
}

export interface AnalyzeResponse {
  usedMode: 'A' | 'B' | 'C';
  normalizedText: string;
  keywords: string[];
  offsets: Array<{ start: number; end: number; token: string }>;
}

async function authedFetch(url: string, body: any, init: RequestInit = {}) {
  const user = getAuth().currentUser;
  if (!user) throw new Error(uiText("Sign-in required"));
  const idToken = await user.getIdToken();
  const resp = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
      ...(init.headers || {}),
    },
    body: JSON.stringify(body),
  });
  if (resp.status === 304) {
    return { status: 304, data: null } as any;
  }
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`Sudachi API Error ${resp.status}: ${text}`);
  }
  const data = await resp.json();
  return { status: resp.status, data };
}

export async function analyzeForSearch(req: AnalyzeRequest): Promise<AnalyzeResponse> {
  const { data } = await authedFetch(ANALYZE_URL, {
    text: req.text,
    workspaceId: req.workspaceId,
    mode: req.mode ?? 'auto',
    normalize: req.normalize ?? true,
    filters: req.filters,
  });
  return data as AnalyzeResponse;
}


